import { z } from 'zod';

export const createAgentSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  slug: z
    .string()
    .min(1, 'Slug is required')
    .regex(/^[a-zA-Z0-9-]+$/, 'Slug must contain only letters, numbers, and hyphens'),
  instruction: z.string().min(1, 'Instruction is required'),
});

export type CreateAgentPayload = z.infer<typeof createAgentSchema>;
